<template>
      <div class="modal fade worli-Bets-Modal forgot-password-modal" ref="setTransactionPasswordModel" id="setTransactionPasswordModel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog" role="document">
            <div class="modal-content wallet_edit_stake_modal">
                <div class="modal-header modal_cmn_header">
                    <h5 class="modal-title"> {{ $t('update-transaction-password','Update Transaction Password') }}</h5>
                </div>
                <div class="modal-body">
                    <div class="withdraw-password-update">
                        <div class="withdraw-instruction">
                            <h4>{{ $t('transaction-instruction', 'Transaction Instructions') }}</h4>
                            <ul>
                                <li>{{ $t('transaction-password-eight-twenty', 'Transaction Password Must be of minimum 8 characters and maximum 20 characters required') }}</li>
                                <li>{{ $t('transaction-password-small-capital', 'Transaction Password Must have atleast 1 small and 1 capital alphabet') }}</li>
                                <li>{{ $t('transaction-password-digit-special-char', 'Transaction Password Must have atleast 1 Digit and 1 Special character') }}</li>
                                <li>{{ $t('please-take-note-your-transaction-password', 'Please take a note of your Transaction Password') }}</li>
                            </ul>
                        </div>
                       
                        <div class="acc-login-form-sec position-relative">
                            <div class="password-field-rel password-input changed_pass_wrapper mb-2">
                                <input v-model="transaction.password" :type="transactionPasswordFieldType" :placeholder="$t('enter-transaction-password', 'Enter Transaction Password*')" class="form-control password-input"
                                    @input="transaction.password = $helper.sanitizeDetails('transactionPassword', transaction.password.replace(/\s/g, ''), 20); validate()" 
                                    :class="isOtpApiCalled && init.password && checkValidation?.transactionPassword?.length > 0 ? 'error-input' : ''" />

                                <div class="showHide-pass">
                                    <i @click="togglePasswordVisibility('transactionPasswordFieldType')" class="fa-solid" :class="transactionPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </div>
                            </div>
                            <section v-if="init.password && checkValidation?.transactionPassword?.length > 0">
                                <section v-for="(err, index) in checkValidation?.transactionPassword" :key="index">
                                    <p class="wallet-error"> {{ $t(err.lang, err.error) }}</p>
                                </section>
                            </section>
                        </div>
                        <div class="acc-login-form-sec position-relative">
                            <div class="password-field-rel mb-2">
                                <input v-model="transaction.confirmPassword" :type="confirmPasswordFieldType" :placeholder="$t('enter-confirm-withdraw-password', 'Enter Confirm Withdraw Password*')" class="form-control password-input"
                                    @input="transaction.confirmPassword = $helper.sanitizeDetails('withdrawPassword', transaction.confirmPassword.replace(/\s/g, ''), 20); validate()" 
                                    :class="init.c_password && checkValidation?.confirmTransactionPassword?.length > 0 ? 'error-input' : ''" />

                                <div class="showHide-pass">
                                    <i @click="togglePasswordVisibility('confirmPasswordFieldType')" class="fa-solid" :class="confirmPasswordFieldType === 'password' ? 'fa-eye-slash' : 'fa-eye'"></i>
                                </div>
                            </div>
                            <section v-if="init.c_password && checkValidation?.confirmTransactionPassword?.length > 0">
                                <section v-for="(err, index) in checkValidation?.confirmTransactionPassword" :key="index">
                                    <p class="wallet-error"> {{ $t(err.lang, err.error) }}</p>
                                </section>
                            </section>
                        </div>
                        <div class="forgot-submit-btn">
                            <button @click="validateTransactionPassword()" class="submit-btn">{{$t('submit','Submit')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validate from "@/modules/authorization/services/authValidation"
import { onUpdateWithdrawTransactionPassword } from "@/modules/account/services/changeAndWithdrawPasswordModal";

export default {
    name: 'SetTransactionPassword',
    data(){
        return{
            transaction:{
                password: null,
                confirmPassword: null,
            },
            validationErrors : null,
            transactionPasswordFieldType : 'password',
            confirmPasswordFieldType: 'password',
            init:{
                c_password:false,
                password:false
            },
        }
    },
    computed:{
        checkValidation() {
			return this.validationErrors;
		}
    },
    methods:{
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'transaction-password',
				this.transaction.password,
				this.transaction.confirmPassword,
            );
            return this.validationErrors;                                                                                                    
        },
        async resetTransactionForm(){
            this.transaction ={
                password: '',
                confirmPassword: ''
            },
            this.validationErrors = null;
            this.toggleInit(false)
        },

        toggleInit(bool){
            this.init={
                c_password:bool,
                password:bool
            }
        },
        togglePasswordVisibility(fieldName) {
                this[fieldName] = this[fieldName] === 'password' ? 'text' : 'password';            
        },
        async validateTransactionPassword() {
            this.toggleInit(true);
            if (Object.keys(this.validate())?.filter(key => ['confirmTransactionPassword', 'transactionPassword'].includes(key))?.length) return;
            const resetResponse = await this.resetTransactionPassword()
            // if transaction password reset fails, return immediately
            if (resetResponse?.error) {
                this.$errorToast(resetResponse?.error);
                return;
            }
            else{
                this.$successToast(resetResponse?.message);
                await this.resetTransactionForm();
                this.$helper.closeModal('setTransactionPasswordModel');
            }
        },
        async resetTransactionPassword(){
            if (!this.transaction.password || this.transaction.password == null) {
                this.$errorToast("New Transaction Password Required!");
                return; 
            }
            if (this.transaction.password != this.transaction.confirmPassword) {
                this.$errorToast("Confirm Transaction Password Does Not Match With New Transaction Password");
                return;
            }
           
            let response = await onUpdateWithdrawTransactionPassword(this.transaction.password);
            return response;
        },
    },
}
</script>